import { markupParser } from '@/shared/lib/markup';

export default {
  methods: {
    markupToPlainText(text) {
      const blocks = markupParser.methods.parseMarkup(text);

      const flattenTokens = (tokens) => tokens
        .map((token) => (token.type === 'link' ? token.label : token.value))
        .join('');

      return blocks
        .map((block) => (block.type === 'list'
          ? block.items.map(flattenTokens).join(' ')
          : block.lines.map(flattenTokens).join(' ')))
        .join(' ');
    },
  },
};
